export default __webpack_public_path__ + "static/media/platform-3.03d3fc94.png";